module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iIzAwNmIzZiIgZD0iTTAgMGg1MTJ2NTEySDB6Ii8+CiAgPHBhdGggZmlsbD0iI2ZjZDExNiIgZD0iTTAgMGg1MTJ2MzQxLjMzM0gweiIvPgogIDxwYXRoIGZpbGw9IiNjZTExMjYiIGQ9Ik0wIDBoNTEydjE3MC42NjdIMHoiLz4KICA8cGF0aCBkPSJNMjU2IDE3MC42NjdsNTUuNDUzIDE3MC42NjYtMTQ1LjE3OC0xMDUuNDc3aDE3OS40NUwyMDAuNTQ3IDM0MS4zMzN6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/gh.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/gh.svg
// module chunks = 0